<div class="content" *ngIf="!error && !isLoading && patientGroup; else innerLoading">
  <msd-patient-group-patient-edit *ngIf="editing; else listing" [patientGroup]="patientGroup" (onClose)="edit(false)" ></msd-patient-group-patient-edit>
  <ng-template #listing>
    <msd-patient-group-patient-list [patientGroup]="patientGroup" (onBack)="onClose.emit()" (onEdit)="edit(true)" ></msd-patient-group-patient-list>
  </ng-template>
</div>

<ng-template #innerLoading>
  <ngx-inner-loading class="flex-center" [error]="!!error"
    [loading]="isLoading" (retry)="loadPatientGroup()" [loadingDescription]="'Chargement...'"
    [errorDescription]="error" [retryButtonText]="'Réessayer'">
  </ngx-inner-loading>
</ng-template>
